import orderBy from 'lodash/orderBy'
import uniqBy from 'lodash/uniqBy'
import { observer } from 'mobx-react'

import { CaseRecordType } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { CheckboxBasedFilter, OptionsProps } from '@avantstay/backoffice-core'

import { ColumnFilterProps } from '@new/domains/operations/screens/CasesV2/CasesV2.types'
import { casesFiltersStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFiltersStore'
import { casesStore } from '@new/domains/operations/screens/CasesV2/stores/CasesStore'
import { CaseFilterIds } from '@new/domains/operations/screens/CasesV2/utils/config'

import * as S from './commonFilterStyles.style'

const _AssignedFOFilter = (props: ColumnFilterProps) => {
  const { recordTypes, assignedFO, setFilterValue } = casesFiltersStore
  const { caseInputs, isLoadingCaseInputs } = casesStore

  const handleDataFilter = (value?: string[]) => {
    setFilterValue(CaseFilterIds.AssignedFO, value)
  }

  const recordTypeOptions = recordTypes?.length ? recordTypes : Object.values(CaseRecordType)
  const options = recordTypeOptions.reduce(
    (acc: OptionsProps<string>[], recordType: CaseRecordType) => {
      const assignedFOList = caseInputs?.[recordType]?.assignedFO
      if (assignedFOList?.length) {
        assignedFOList.forEach(assignedFO => {
          acc.push({
            value: assignedFO.id,
            label: assignedFO.name.trim(),
            hasFullWidth: true,
          })
        })
      }
      return acc
    },
    [] as OptionsProps<string>[],
  ) as OptionsProps<string>[]

  return (
    <S.CheckBoxWrapper>
      <CheckboxBasedFilter
        title="Assigned FO"
        options={orderBy(uniqBy(options, 'value'), 'label')}
        isLoadingOptions={isLoadingCaseInputs}
        initialValue={assignedFO}
        onChange={handleDataFilter}
        {...props}
      />
    </S.CheckBoxWrapper>
  )
}

export const AssignedFOFilter = observer(_AssignedFOFilter)
